var formatTime = function (time) {
    var hours = Math.floor(time / 3600);
    var minute = Math.floor((time - hours * 3600) / 60);
    var second = Math.floor(time % 60);
    var minuteDisplay = minute < 10 ? "0" + minute : minute;
    var secondDisplay = second < 10 ? "0" + second : second;
    return "" + (hours > 0 ? hours + ":" : '') + minuteDisplay + ":" + secondDisplay;
};
export default formatTime;
//# sourceMappingURL=formatTime.js.map